import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import HierarchicalListNode from './HierarchicalListNode';

const useStyles = buildUseStyles('HierarchicalList', (() => ({
  root: {},
})));

const HierarchicalList = ({
  collection,
  onClickItem,
}) => {
  const classes = useStyles();
  return (
    <Box
      className={classes.root}
    >
      {collection.resources().list().map((resource) => {
        return (
          <HierarchicalListNode
            key={resource.id()}
            isChild={false}
            resource={resource}
            onClickItem={onClickItem}
          />
        );
      })}
    </Box>
  );
};

HierarchicalList.defaultProps = {
  onClickItem: null,
};

HierarchicalList.propTypes = {
  collection: PropTypes.object.isRequired,
  onClickItem: PropTypes.func,
};

export default HierarchicalList;
